import React from 'react';
import PropTypes from 'prop-types';
import {
    PadContainer,
    Ticket,
    TicketBody,
    TicketHeader,
    icons,
} from 'smartsuite-ui';
import TextOrLinkTitle from '../../../../../shared/TextOrLinkTitle';
import useLink from '../../../../../shared/hooks/linkHooks';

export default function NationalKpiListItem(props) {
    const kpiLink = useLink(props.linkConfig, props.metricRequest, props.item);

    return (
        <Ticket key={props.item.kpiName}>
            <TicketHeader>
                <div
                    className="national-kpi-list__item-header"
                    title={props.item.kpiName}
                >
                    <TextOrLinkTitle
                        title={props.item.kpiName}
                        navigationLink={kpiLink}
                        openLinkInNewTab={props.openLinkInNewTab}
                    />
                </div>
            </TicketHeader>
            <TicketBody>
                <div className="national-kpi-list__item-body">
                    <div className="national-kpi-list__item-value">
                        {props.item.value}
                    </div>
                    <div className="national-kpi-list__item-target">
                        <span className={icons.target} />
                        <PadContainer cssClassModifiers={['pad-small']} />
                        <span>{props.item.target}</span>
                    </div>
                </div>
            </TicketBody>
        </Ticket>
    );
}

NationalKpiListItem.propTypes = {
    item: PropTypes.instanceOf(Object).isRequired,
    linkConfig: PropTypes.instanceOf(Object),
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    openLinkInNewTab: PropTypes.bool,
};
